var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome_container"},[_c('div',{staticClass:"welcome_card"},[_c('p',[_vm._v("欢迎使用后台管理系统!")])])])}]

export { render, staticRenderFns }